import React, { useState } from 'react';
import { Shield, Zap, Target, Trophy, ArrowRight, CheckCircle2, Star, Clock, Gift, Brain, ChevronDown } from 'lucide-react';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
import { Countdown } from './components/Countdown';
import { AccordionItem } from './components/Accordion';
import { modulesData, bonusesData } from './data/content';
const CHECKOUT_URL = 'https://checkout.ebookpoint.shop/cart/59546532184145:1';
export function App() {
  const [openModule, setOpenModule] = useState<number | null>(0);
  const [openBonus, setOpenBonus] = useState<number | null>(null);
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const handleBuyClick = () => {
    window.location.href = CHECKOUT_URL;
  };
  const scrollToBuy = () => {
    const el = document.getElementById('compra');
    if (el) el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <div className="min-h-screen bg-[#1F6B1F] font-sans text-white selection:bg-white selection:text-green-800" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      {/* HERO SECTION */}
      <section className="relative bg-[#14532D] text-white pt-12 pb-20 px-4 overflow-hidden" data-id="element-3">
        {/* Pitch background effect */}
        <div className="absolute inset-0 opacity-20" style={{
        backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 40px, rgba(255,255,255,0.08) 40px, rgba(255,255,255,0.08) 80px)',
        backgroundSize: '100% 80px'
      }} data-id="element-4"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#1F6B1F]" data-id="element-5"></div>

        <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-6">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/30 text-white text-sm font-bold mb-6" data-id="element-7">
            <Zap className="w-4 h-4" data-id="element-8" />
            <span data-id="element-9">
              SISTEMA DE ENTRENAMIENTO PARA FUTBOLISTAS DE TODOS LOS NIVELES
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl font-black mb-10 leading-tight tracking-tight" data-id="element-10">
            Tu cabeza ve la jugada,{' '}
            <span className="text-white drop-shadow-[0_0_20px_rgba(255,255,255,0.4)] underline decoration-white/40 decoration-4 underline-offset-8" data-id="element-11">
              pero tu cuerpo llega tarde
            </span>
          </h1>

          <div className="relative max-w-[81%] sm:max-w-[60.5%] mx-auto mb-10 cursor-pointer group" onClick={scrollToBuy} data-id="element-12">
            <div className="absolute -inset-4 bg-white/10 blur-3xl rounded-full" data-id="element-13"></div>
            <img src="https://cdn.magicpatterns.com/uploads/vqe3zUESv1UfXVxay7mGt9/ChatGPT_Image_May_20,_2026,_05_40_24_PM.png" alt="Futbol Explosivo Pro" className="relative rounded-2xl shadow-2xl object-contain w-full group-hover:scale-[1.02] transition-transform duration-300" data-id="element-14" />
          </div>

          <p className="text-lg md:text-xl text-green-50 mb-10 max-w-2xl mx-auto font-medium" data-id="element-15">
            El programa definitivo para jugadores que quieren ser más
            explosivos, ganar cada duelo y patear más fuerte, sin lesionarse en
            el intento.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-10 text-sm font-medium" data-id="element-16">
            <div className="flex items-center gap-2 bg-white/15 px-4 py-2 rounded-full border border-white/20" data-id="element-17">
              <Shield className="w-4 h-4 text-white" data-id="element-18" />
              <span data-id="element-19">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-2 bg-white/15 px-4 py-2 rounded-full border border-white/20" data-id="element-20">
              <Zap className="w-4 h-4 text-white" data-id="element-21" />
              <span data-id="element-22">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-2 bg-white/15 px-4 py-2 rounded-full border border-white/20" data-id="element-23">
              <Trophy className="w-4 h-4 text-white" data-id="element-24" />
              <span data-id="element-25">Nivel Amateur a Pro</span>
            </div>
          </div>

          <button onClick={scrollToBuy} className="group relative inline-flex items-center justify-center gap-3 bg-white text-[#1F6B1F] text-xl md:text-2xl font-black py-5 px-10 rounded-2xl shadow-[0_10px_40px_-10px_rgba(255,255,255,0.5)] hover:shadow-[0_10px_50px_-10px_rgba(255,255,255,0.8)] hover:scale-105 transition-all duration-300 w-full md:w-auto" data-id="element-26">
            <span className="absolute -top-3 -right-3 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full animate-bounce shadow-lg" data-id="element-27">
              ¡OFERTA HOY!
            </span>
            <span data-id="element-28">DEJA DE LLEGAR TARDE A LA PELOTA</span>
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-29" />
          </button>
        </div>
      </section>

      {/* PROBLEM / SOLUTION SECTION */}
      <section className="py-20 px-4 bg-[#1F6B1F]" data-id="element-30">
        <div className="max-w-4xl mx-auto" data-id="element-31">
          <div className="text-center mb-16" data-id="element-32">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-6" data-id="element-33">
              ¿Te pasa esto en la cancha?
            </h2>
            <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-34">
              <div className="bg-white p-6 rounded-2xl border-4 border-red-200 shadow-xl" data-id="element-35">
                <h3 className="font-bold text-red-600 mb-4 text-lg uppercase" data-id="element-36">
                  Lo que te frena hoy
                </h3>
                <ul className="space-y-4" data-id="element-37">
                  <li className="flex items-start gap-3" data-id="element-38">
                    <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-39" />
                    <span className="text-gray-700 font-medium" data-id="element-40">
                      Llegás tarde a las pelotas divididas y perdés los
                      anticipos.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-41">
                    <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-42" />
                    <span className="text-gray-700 font-medium" data-id="element-43">
                      Le pegás a la pelota y sale sin fuerza, o forzás tanto que
                      perdés precisión.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-44">
                    <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-45" />
                    <span className="text-gray-700 font-medium" data-id="element-46">
                      Vas al gimnasio pero te sentís "pesado" o lento en la
                      cancha.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-47">
                    <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-48" />
                    <span className="text-gray-700 font-medium" data-id="element-49">
                      Te fundís rápido o te lesionás seguido (isquios,
                      aductores).
                    </span>
                  </li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-2xl border-4 border-[#1F6B1F]/30 shadow-xl" data-id="element-50">
                <h3 className="font-bold text-[#1F6B1F] mb-4 text-lg uppercase" data-id="element-51">
                  Con Fútbol Explosivo Pro
                </h3>
                <ul className="space-y-4" data-id="element-52">
                  <li className="flex items-start gap-3" data-id="element-53">
                    <CheckCircle2 className="w-6 h-6 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-54" />
                    <span className="text-gray-800 font-medium" data-id="element-55">
                      Ganar explosión en los primeros 5 metros (donde se define
                      el fútbol).
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-56">
                    <CheckCircle2 className="w-6 h-6 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-57" />
                    <span className="text-gray-800 font-medium" data-id="element-58">
                      Aumentar drásticamente tu potencia de remate con técnica
                      correcta.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-59">
                    <CheckCircle2 className="w-6 h-6 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-60" />
                    <span className="text-gray-800 font-medium" data-id="element-61">
                      Desarrollar "fuerza útil" que se transfiere directamente
                      al partido.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-62">
                    <CheckCircle2 className="w-6 h-6 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-63" />
                    <span className="text-gray-800 font-medium" data-id="element-64">
                      Prevenir lesiones comunes con rutinas específicas para
                      futbolistas.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MODULES SECTION */}
      <section className="py-20 px-4 bg-[#14532D] border-t border-white/10" data-id="element-65">
        <div className="max-w-3xl mx-auto" data-id="element-66">
          <div className="text-center mb-12" data-id="element-67">
            <span className="text-white/80 font-bold tracking-wider uppercase text-sm" data-id="element-68">
              El Programa Principal
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-white mt-2 mb-4" data-id="element-69">
              ¿Qué incluye el programa?
            </h2>
            <p className="text-green-100 text-lg" data-id="element-70">
              5 tomos estructurados paso a paso para transformar tu físico.
            </p>
          </div>

          <div className="space-y-2" data-id="element-71">
            {modulesData.map((module, index) => <AccordionItem key={index} title={module.title} subtitle={module.subtitle} content={module.content} isOpen={openModule === index} onClick={() => setOpenModule(openModule === index ? null : index)} data-id="element-72" />)}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS SECTION */}
      <section className="py-20 px-4 bg-[#1F6B1F]" data-id="element-73">
        <div className="max-w-5xl mx-auto" data-id="element-74">
          <div className="text-center mb-12" data-id="element-75">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-76">
              Jugadores que ya son más explosivos
            </h2>
            <div className="flex justify-center gap-1 text-amber-300" data-id="element-77">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-current" data-id="element-78" />)}
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-79">
            <TestimonialCard name="Martín F." age="24 años" role="Delantero" text="Siempre fui rápido pero me pasaba de largo o me ganaban con el cuerpo. Con el Tomo 3 de fuerza útil y los ejercicios de frenada, ahora gano los duelos y defino con mucho más equilibrio. Un antes y un después para el fútbol 11." data-id="element-80" />
            <TestimonialCard name="Lucas G." age="28 años" role="Volante" text="Juego fútbol 7 con amigos y me fundía a los 20 minutos. Empecé a aplicar las rutinas express porque no tengo tiempo de ir al gym. Mejoré mi arranque y la potencia de mi pegada de afuera del área es otra cosa." data-id="element-81" />
            <TestimonialCard name="Diego S." age="31 años" role="Defensor" text="Venía de dos desgarros seguidos en los isquios. El bono anti-lesiones vale oro. Hace 4 meses que no me pierdo un partido y me siento mucho más seguro en los giros y cierres rápidos." data-id="element-82" />
            <TestimonialCard name="Tomás R." age="22 años" role="Extremo" text="Pensé que pateaba fuerte hasta que vi el módulo de técnica de remate. Corregí el pie de apoyo y la rotación de cadera y ahora la pelota sale como un misil. Mis compañeros me preguntan qué estoy tomando jaja." data-id="element-83" />
            <TestimonialCard name="Alejandro M." age="35 años" role="Lateral" text="A mi edad pensé que ya no podía ser más rápido. El plan de 12 semanas me ordenó. Dejé de hacer rutinas de culturista y me enfoqué en potencia. Me siento más ágil que a los 25." data-id="element-84" />
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-20 px-4 bg-[#14532D] text-white relative overflow-hidden" data-id="element-85">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-86">
          <div className="absolute w-[800px] h-[800px] rounded-full border-[40px] border-white -top-[400px] -right-[200px]" data-id="element-87"></div>
          <div className="absolute w-[600px] h-[600px] rounded-full border-[20px] border-white -bottom-[300px] -left-[100px]" data-id="element-88"></div>
        </div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-89">
          <div className="text-center mb-12" data-id="element-90">
            <div className="inline-block bg-white text-[#1F6B1F] font-black px-4 py-1 rounded-full text-sm mb-4 transform -rotate-2 shadow-lg" data-id="element-91">
              GRATIS SOLO POR HOY
            </div>
            <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-92">
              Bonos Exclusivos Comprando HOY
            </h2>
            <p className="text-green-100 text-lg" data-id="element-93">
              8 complementos premium valorados en más de{' '}
              <span className="font-black text-white" data-id="element-94">$60.000</span>, totalmente
              gratis si te sumás hoy.
            </p>
          </div>

          <div className="space-y-2" data-id="element-95">
            {bonusesData.map((bonus, index) => <AccordionItem key={index} title={bonus.title} subtitle={bonus.subtitle} content={bonus.content} isOpen={openBonus === index} onClick={() => setOpenBonus(openBonus === index ? null : index)} isBonus={true} data-id="element-96" />)}
          </div>
        </div>
      </section>

      {/* PRICING & CTA SECTION */}
      <section id="compra" className="py-20 px-4 bg-[#1F6B1F] border-t border-white/10 scroll-mt-4" data-id="element-97">
        <div className="max-w-3xl mx-auto text-center" data-id="element-98">
          <Countdown data-id="element-99" />

          <div className="bg-white border-4 border-[#1F6B1F] rounded-3xl p-6 md:p-10 shadow-2xl relative mt-8" data-id="element-100">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#1F6B1F] text-white font-black px-6 py-2 rounded-full shadow-lg border-4 border-white whitespace-nowrap" data-id="element-101">
              OFERTA ESPECIAL
            </div>

            <h2 className="text-2xl md:text-3xl font-black text-gray-900 mt-4 mb-2" data-id="element-102">
              Fútbol Explosivo Pro
            </h2>
            <p className="text-gray-600 mb-6 font-medium text-sm md:text-base" data-id="element-103">
              Programa completo + 8 bonos exclusivos
            </p>

            {/* VALUE STACK */}
            <div className="bg-[#1F6B1F]/5 border border-[#1F6B1F]/20 rounded-2xl p-5 md:p-6 mb-6 text-left" data-id="element-104">
              <p className="text-xs font-black text-[#1F6B1F] uppercase tracking-wider mb-4 text-center" data-id="element-105">
                Esto es todo lo que vas a recibir
              </p>
              <ul className="space-y-2.5 text-sm md:text-[15px] text-gray-800" data-id="element-106">
                <li className="flex items-start justify-between gap-3" data-id="element-107">
                  <span className="flex items-start gap-2 min-w-0" data-id="element-108">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-109" />
                    <span data-id="element-110">
                      <strong data-id="element-111">Programa principal</strong> · 5 tomos (250 págs)
                    </span>
                  </span>
                  <span className="text-gray-400 line-through text-xs md:text-sm flex-shrink-0" data-id="element-112">
                    $29.990
                  </span>
                </li>
                <li className="flex items-start justify-between gap-3" data-id="element-113">
                  <span className="flex items-start gap-2 min-w-0" data-id="element-114">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-115" />
                    <span data-id="element-116">
                      <strong data-id="element-117">Bono 1:</strong> Tests de velocidad, potencia y
                      pegada
                    </span>
                  </span>
                  <span className="text-gray-400 line-through text-xs md:text-sm flex-shrink-0" data-id="element-118">
                    $4.990
                  </span>
                </li>
                <li className="flex items-start justify-between gap-3" data-id="element-119">
                  <span className="flex items-start gap-2 min-w-0" data-id="element-120">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-121" />
                    <span data-id="element-122">
                      <strong data-id="element-123">Bono 2:</strong> Rutinas express de 20 minutos
                    </span>
                  </span>
                  <span className="text-gray-400 line-through text-xs md:text-sm flex-shrink-0" data-id="element-124">
                    $4.990
                  </span>
                </li>
                <li className="flex items-start justify-between gap-3" data-id="element-125">
                  <span className="flex items-start gap-2 min-w-0" data-id="element-126">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-127" />
                    <span data-id="element-128">
                      <strong data-id="element-129">Bono 3:</strong> Plan anti-lesiones
                    </span>
                  </span>
                  <span className="text-gray-400 line-through text-xs md:text-sm flex-shrink-0" data-id="element-130">
                    $4.990
                  </span>
                </li>
                <li className="flex items-start justify-between gap-3" data-id="element-131">
                  <span className="flex items-start gap-2 min-w-0" data-id="element-132">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-133" />
                    <span data-id="element-134">
                      <strong data-id="element-135">Bono 4:</strong> Plan por posición
                    </span>
                  </span>
                  <span className="text-gray-400 line-through text-xs md:text-sm flex-shrink-0" data-id="element-136">
                    $4.990
                  </span>
                </li>
                <li className="flex items-start justify-between gap-3" data-id="element-137">
                  <span className="flex items-start gap-2 min-w-0" data-id="element-138">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-139" />
                    <span data-id="element-140">
                      <strong data-id="element-141">Bono 5:</strong> Planillas + calendario imprimible
                    </span>
                  </span>
                  <span className="text-gray-400 line-through text-xs md:text-sm flex-shrink-0" data-id="element-142">
                    $4.990
                  </span>
                </li>
                <li className="flex items-start justify-between gap-3" data-id="element-143">
                  <span className="flex items-start gap-2 min-w-0" data-id="element-144">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-145" />
                    <span data-id="element-146">
                      <strong data-id="element-147">Bono 6:</strong> Sistema definitivo de pegada y
                      potencia
                    </span>
                  </span>
                  <span className="text-gray-400 line-through text-xs md:text-sm flex-shrink-0" data-id="element-148">
                    $6.990
                  </span>
                </li>
                <li className="flex items-start justify-between gap-3" data-id="element-149">
                  <span className="flex items-start gap-2 min-w-0" data-id="element-150">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-151" />
                    <span data-id="element-152">
                      <strong data-id="element-153">Bono 7:</strong> Fuerza, estabilidad y
                      anti-lesiones
                    </span>
                  </span>
                  <span className="text-gray-400 line-through text-xs md:text-sm flex-shrink-0" data-id="element-154">
                    $6.990
                  </span>
                </li>
                <li className="flex items-start justify-between gap-3" data-id="element-155">
                  <span className="flex items-start gap-2 min-w-0" data-id="element-156">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-157" />
                    <span data-id="element-158">
                      <strong data-id="element-159">Bono 8:</strong> Primer toque, agilidad y
                      velocidad mental
                    </span>
                  </span>
                  <span className="text-gray-400 line-through text-xs md:text-sm flex-shrink-0" data-id="element-160">
                    $6.990
                  </span>
                </li>
                <li className="flex items-start justify-between gap-3 pt-2.5 border-t border-[#1F6B1F]/20" data-id="element-161">
                  <span className="flex items-start gap-2 min-w-0" data-id="element-162">
                    <Gift className="w-4 h-4 md:w-5 md:h-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-163" />
                    <span className="font-bold" data-id="element-164">
                      Regalo: Psicología Deportiva
                    </span>
                  </span>
                  <span className="text-amber-600 font-black text-xs md:text-sm flex-shrink-0" data-id="element-165">
                    GRATIS
                  </span>
                </li>
                <li className="flex items-start justify-between gap-3" data-id="element-166">
                  <span className="flex items-start gap-2 min-w-0" data-id="element-167">
                    <Gift className="w-4 h-4 md:w-5 md:h-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-168" />
                    <span className="font-bold" data-id="element-169">
                      Regalo: Calculadora de proteínas e hidratación
                    </span>
                  </span>
                  <span className="text-amber-600 font-black text-xs md:text-sm flex-shrink-0" data-id="element-170">
                    GRATIS
                  </span>
                </li>
              </ul>

              <div className="mt-5 pt-4 border-t-2 border-dashed border-[#1F6B1F]/30 flex items-center justify-between" data-id="element-171">
                <span className="text-xs md:text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-172">
                  Valor total
                </span>
                <span className="text-gray-500 line-through font-bold text-lg md:text-xl" data-id="element-173">
                  $75.910
                </span>
              </div>
            </div>

            <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-174">
              Tu precio HOY
            </p>
            <div className="flex flex-col items-center justify-center mb-6" data-id="element-175">
              <div className="flex items-baseline gap-1" data-id="element-176">
                <span className="text-[#1F6B1F] font-bold text-3xl md:text-4xl" data-id="element-177">
                  $
                </span>
                <span className="text-[#1F6B1F] font-black text-6xl md:text-7xl tracking-tighter" data-id="element-178">
                  19.990
                </span>
                <span className="text-[#1F6B1F] font-bold text-lg md:text-xl ml-1" data-id="element-179">
                  ARS
                </span>
              </div>
              <p className="text-sm md:text-base text-white font-black bg-[#1F6B1F] px-4 py-1.5 rounded-full mt-3 shadow" data-id="element-180">
                Ahorrás $55.920 hoy · 74% OFF
              </p>
            </div>

            <button onClick={handleBuyClick} className="group relative inline-flex items-center justify-center gap-3 bg-[#1F6B1F] hover:bg-[#14532D] text-white text-lg md:text-2xl font-black py-5 px-6 rounded-2xl shadow-[0_10px_40px_-10px_rgba(31,107,31,0.6)] hover:shadow-[0_10px_50px_-10px_rgba(31,107,31,0.9)] hover:scale-105 transition-all duration-300 w-full mb-4" data-id="element-181">
              <span data-id="element-182">SÍ, QUIERO EL PROGRAMA AHORA</span>
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-183" />
            </button>

            <div className="flex flex-col items-center gap-3 text-sm text-gray-500 font-medium" data-id="element-184">
              <div className="flex items-center gap-6 flex-wrap justify-center" data-id="element-185">
                <div className="flex items-center gap-2" data-id="element-186">
                  <Shield className="w-5 h-5 text-[#1F6B1F]" data-id="element-187" />
                  <span data-id="element-188">Pago 100% Seguro</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-189">
                  <Clock className="w-5 h-5 text-[#1F6B1F]" data-id="element-190" />
                  <span data-id="element-191">Acceso de por vida</span>
                </div>
              </div>
              <div className="flex items-center gap-2" data-id="element-192">
                <img src="https://logospng.org/download/mercado-pago/logo-mercado-pago-icono-1024.png" alt="Mercado Pago" className="h-6 object-contain grayscale opacity-60" data-id="element-193" />
                <span data-id="element-194">Aceptamos Mercado Pago y Tarjetas</span>
              </div>
            </div>
          </div>

          {/* EXTRA GIFT BANNERS */}
          <div className="mt-8 space-y-4" data-id="element-195">
            <div onClick={handleBuyClick} className="cursor-pointer group bg-white border-4 border-[#1F6B1F] rounded-2xl p-6 shadow-2xl hover:scale-[1.02] transition-transform duration-300" role="button" tabIndex={0} data-id="element-196">
              <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-center md:text-left" data-id="element-197">
                <div className="bg-[#1F6B1F] p-3 rounded-full shadow-lg flex-shrink-0" data-id="element-198">
                  <Gift className="w-8 h-8 text-white" data-id="element-199" />
                </div>
                <div data-id="element-200">
                  <p className="text-xs font-black text-[#1F6B1F] uppercase tracking-wider mb-1" data-id="element-201">
                    🎁 Regalo extra
                  </p>
                  <p className="text-lg md:text-xl font-black text-gray-900 leading-tight" data-id="element-202">
                    Comprando HOY llevate una calculadora de proteínas e
                    hidratación
                  </p>
                </div>
              </div>
            </div>

            <div onClick={handleBuyClick} className="cursor-pointer group bg-white border-4 border-amber-400 rounded-2xl p-6 shadow-2xl hover:scale-[1.02] transition-transform duration-300" role="button" tabIndex={0} data-id="element-203">
              <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-center md:text-left" data-id="element-204">
                <div className="bg-amber-400 p-3 rounded-full shadow-lg flex-shrink-0" data-id="element-205">
                  <Brain className="w-8 h-8 text-amber-950" data-id="element-206" />
                </div>
                <div data-id="element-207">
                  <p className="text-xs font-black text-amber-600 uppercase tracking-wider mb-1" data-id="element-208">
                    🧠 Regalo extra · Psicología Deportiva
                  </p>
                  <p className="text-lg md:text-xl font-black text-gray-900 leading-tight" data-id="element-209">
                    Cómo enfrentar las derrotas y las victorias
                  </p>
                  <p className="text-sm text-gray-600 mt-1 font-medium" data-id="element-210">
                    El manual mental para sostener el rendimiento en cualquier
                    contexto.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ / OBJECTIONS SECTION */}
      <section className="py-20 px-4 bg-[#14532D] border-t border-white/10" data-id="element-211">
        <div className="max-w-3xl mx-auto" data-id="element-212">
          <div className="text-center mb-10" data-id="element-213">
            <span className="text-white/80 font-bold tracking-wider uppercase text-sm" data-id="element-214">
              Antes de empezar
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-white mt-2 mb-3" data-id="element-215">
              Preguntas frecuentes
            </h2>
            <p className="text-green-100 text-lg" data-id="element-216">
              Resolvemos las dudas que más nos hacen los jugadores.
            </p>
          </div>

          <div className="space-y-3" data-id="element-217">
            {faqData.map((item, index) => <FaqItem key={index} question={item.question} answer={item.answer} isOpen={openFaq === index} onClick={() => setOpenFaq(openFaq === index ? null : index)} data-id="element-218" />)}
          </div>

          <div className="text-center mt-10" data-id="element-219">
            <button onClick={scrollToBuy} className="inline-flex items-center justify-center gap-3 bg-white text-[#1F6B1F] text-base md:text-lg font-black py-4 px-8 rounded-2xl shadow-xl hover:scale-105 transition-all duration-300" data-id="element-220">
              <span data-id="element-221">QUIERO EMPEZAR HOY</span>
              <ArrowRight className="w-5 h-5" data-id="element-222" />
            </button>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-[#0a2f10] text-green-100/70 py-8 text-center text-sm" data-id="element-223">
        <p data-id="element-224">© 2026 Futbol Explosivo Pro. Todos los derechos reservados.</p>
        <p className="mt-2 text-xs opacity-60" data-id="element-225">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
      </footer>
    </div>;
}
function XIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-226">
      <path d="M18 6 6 18" data-id="element-227" />
      <path d="m6 6 12 12" data-id="element-228" />
    </svg>;
}
const faqData = [{
  question: 'No tengo tiempo, ¿igual me sirve?',
  answer: 'Sí. El sistema incluye rutinas express de 20 minutos diseñadas para futbolistas con poco tiempo. Con 2 a 3 sesiones cortas por semana ya vas a notar diferencias en el primer mes.'
}, {
  question: 'Soy principiante, ¿es para mí?',
  answer: 'Totalmente. El Tomo 1 te ayuda a diagnosticar tu punto de partida y el plan se adapta a 3 niveles (principiante, intermedio y competitivo). Vas a progresar a tu ritmo, sin saltarte etapas ni lesionarte.'
}, {
  question: 'No tengo gimnasio ni equipamiento, ¿igual funciona?',
  answer: 'Sí. El programa incluye versión sin gimnasio con peso corporal, bandas elásticas y la pelota. Lo único que necesitás es un espacio de 5x5 metros y ganas. Si tenés gym, hay versión con cargas también.'
}, {
  question: '¿Sirve para fútbol 5, 7 y 11?',
  answer: 'Sí. Cada formato tiene adaptaciones específicas dentro del plan: fútbol 5 con foco en reacción y cambios de dirección cortos, fútbol 7 en transiciones y duelos, y fútbol 11 en sprint repetido y resistencia explosiva.'
}, {
  question: '¿Y si soy "grande" (30+ años)?',
  answer: 'El sistema funciona a cualquier edad. Tenemos jugadores de 18 a 45+ años aplicándolo. La clave es el sistema anti-lesiones y la progresión inteligente: no se trata de entrenar más, sino mejor.'
}, {
  question: 'Ya entreno, ¿qué me aporta esto distinto?',
  answer: 'Estructura, medición y transferencia real al partido. La mayoría hace ejercicios sueltos sin saber si están atacando su debilidad real. Acá tenés diagnóstico, prioridad clara y un plan de 12 semanas probado.'
}, {
  question: '¿Cómo lo recibo después de comprar?',
  answer: 'Acceso inmediato. Apenas confirmás el pago te llega un email con el link de descarga de todos los PDFs y planillas. Lo podés leer en cualquier dispositivo (celular, tablet, PC) y lo tenés para siempre.'
}, {
  question: '¿Y si no me sirve?',
  answer: 'Tenés 7 días de garantía. Si aplicás el sistema y no notás mejoras o no te convence, te devolvemos el 100% de tu dinero sin preguntas. El riesgo es nuestro, no tuyo.'
}, {
  question: 'No me lesiono seguido, ¿igual necesito el bono anti-lesiones?',
  answer: 'Sí. Las lesiones más comunes (isquios, aductores, tobillo) aparecen cuando aumenta la intensidad. Si vas a entrenar más explosivo, blindar el cuerpo antes es lo que te asegura sostener el progreso.'
}, {
  question: '¿Puedo pagar en pesos argentinos?',
  answer: 'Sí. Todo el pago es en pesos argentinos a través de Mercado Pago, tarjetas de crédito y débito, o efectivo (Pago Fácil/Rapipago). Sin sorpresas ni costos extra.'
}];
function FaqItem({
  question,
  answer,
  isOpen,
  onClick
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <div className={`rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'bg-white shadow-xl' : 'bg-white/10 hover:bg-white/15 backdrop-blur-sm'}`} data-id="element-229">
      <button onClick={onClick} className="w-full flex items-center justify-between p-5 text-left gap-4" data-id="element-230">
        <span className={`font-bold text-base md:text-lg leading-tight ${isOpen ? 'text-gray-900' : 'text-white'}`} data-id="element-231">
          {question}
        </span>
        <div className={`p-2 rounded-full flex-shrink-0 transition-transform duration-300 ${isOpen ? 'bg-[#1F6B1F]/10 text-[#1F6B1F] rotate-180' : 'bg-white/20 text-white'}`} data-id="element-232">
          <ChevronDown className="w-4 h-4" data-id="element-233" />
        </div>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-234">
        <p className="px-5 pb-5 text-gray-700 text-sm md:text-base leading-relaxed" data-id="element-235">
          {answer}
        </p>
      </div>
    </div>;
}
function TestimonialCard({
  name,
  age,
  role,
  text
}: {
  name: string;
  age: string;
  role: string;
  text: string;
}) {
  return <div className="bg-white p-6 rounded-2xl shadow-xl border border-green-100 flex flex-col h-full" data-id="element-236">
      <div className="flex text-amber-400 mb-4" data-id="element-237">
        {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-238" />)}
      </div>
      <p className="text-gray-700 mb-6 flex-grow italic" data-id="element-239">"{text}"</p>
      <div className="flex items-center gap-3 mt-auto pt-4 border-t border-gray-50" data-id="element-240">
        <div className="w-10 h-10 bg-[#1F6B1F] rounded-full flex items-center justify-center text-white font-bold" data-id="element-241">
          {name.charAt(0)}
        </div>
        <div data-id="element-242">
          <p className="font-bold text-gray-900 text-sm" data-id="element-243">{name}</p>
          <p className="text-xs text-gray-500" data-id="element-244">
            {age} • {role}
          </p>
        </div>
      </div>
    </div>;
}